import { render, staticRenderFns } from "./MajorsMian.vue?vue&type=template&id=4e2e13c6&scoped=true"
import script from "./MajorsMian.vue?vue&type=script&lang=js"
export * from "./MajorsMian.vue?vue&type=script&lang=js"
import style0 from "./MajorsMian.vue?vue&type=style&index=0&id=4e2e13c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e2e13c6",
  null
  
)

export default component.exports